export default __webpack_public_path__ + "static/media/tradingview.fdbd91e6.svg";